import { c as _c } from "react/compiler-runtime";
import type * as React from 'react';
import { useIsClient } from 'foxact/use-is-client';
import { useAtom } from 'jotai';
import { Button as AriaButton, FileTrigger } from 'react-aria-components';
import { fileTypesAtom } from '@/atoms/file-types';
import { Button } from '@/components/ui/button';
import { getFileContent, SUPPORTED_FILE_TYPES } from '@/lib/filesHandler';
export function FileInput(t0) {
  const $ = _c(20);
  const {
    onFileSelect,
    children,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const [fileTypes] = useAtom(fileTypesAtom);
  let t2;
  if ($[0] !== fileTypes) {
    const fileTypeNames = fileTypes.filter(_temp).map(_temp2);
    t2 = [...SUPPORTED_FILE_TYPES, ...fileTypeNames];
    $[0] = fileTypes;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const acceptedFileTypes = t2;
  const isClient = useIsClient();
  let t3;
  if ($[2] !== onFileSelect) {
    t3 = ev => {
      ev.preventDefault();
      const files = ev.dataTransfer.files;
      if (files) {
        getFileContent(files).then(onFileSelect).catch(console.error);
      }
    };
    $[2] = onFileSelect;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== onFileSelect) {
    t4 = fileList => {
      if (fileList) {
        getFileContent(fileList).then(onFileSelect).catch(console.error);
      }
    };
    $[4] = onFileSelect;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== children || $[7] !== isClient) {
    t5 = isClient ? <AriaButton>{children}</AriaButton> : children;
    $[6] = children;
    $[7] = isClient;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== isClient || $[10] !== t5) {
    t6 = <div><Button variant="outline" asChild={isClient}>{t5}</Button></div>;
    $[9] = isClient;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== acceptedFileTypes || $[13] !== t4 || $[14] !== t6) {
    t7 = <FileTrigger allowsMultiple={true} acceptedFileTypes={acceptedFileTypes} onSelect={t4}>{t6}</FileTrigger>;
    $[12] = acceptedFileTypes;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== className || $[17] !== t3 || $[18] !== t7) {
    t8 = <div onDrop={t3} className={className}>{t7}</div>;
    $[16] = className;
    $[17] = t3;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}
function _temp2(fileType_0) {
  return fileType_0.type;
}
function _temp(fileType) {
  return fileType.checked;
}